module.exports = __webpack_public_path__ + "static/media/pseudohomophoneIsOver.fc309afb.mp3";